import SectionHeading from './SectionHeading';
import { notices } from '@/mocks/homeData';

export default function Notice() {
  return (
    <section id="notice" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            eyebrow="使用提示"
            title="访问入口时，请留意这几件事"
            desc="入口信息具有时效性，养成良好的核对习惯，能让你用得更安心。"
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {notices.map((item, idx) => (
              <div
                key={item.title}
                className={`rounded-lg p-5 md:p-6 border ${
                  idx === 1
                    ? 'bg-accent-100 border-accent-200'
                    : 'bg-background-50 border-background-200'
                }`}
              >
                <div
                  className={`w-11 h-11 flex items-center justify-center rounded-md ${
                    idx === 1 ? 'bg-accent-500 text-background-50' : 'bg-primary-100 text-primary-700'
                  }`}
                >
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}